import { Stack } from "@mui/material"
import { getIconClass } from "@omnia/shared/utils/utils"
import { ButtonHTMLAttributes, DetailedHTMLProps, PropsWithChildren, ReactNode } from "react"
import { classes } from "../react"

export type ButtonProps = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> &
    (
        | {
              iconClassName?: string
              icon?: never
          }
        | { icon?: ReactNode; iconClassName?: string }
    ) & {
        variant?: "link" | "danger" | "warning" | "info" | "success" | "primary" | "default"
        endElement?: ReactNode
    }

export function Button({
    children,
    className,
    icon,
    iconClassName,
    variant = "default",
    endElement,
    ...props
}: PropsWithChildren<ButtonProps>) {
    const iconElement = iconClassName ? <i className={getIconClass(iconClassName)} /> : icon ? icon : null

    return (
        <Stack
            display="inline-flex"
            direction="row"
            alignItems="center"
            gap={0.8}
            justifyContent="center"
            component="button"
            {...(props as any)}
            type="button"
            className={classes(
                "btn",
                {
                    [`btn-${variant}`]: Boolean(variant),
                    "btn-with-icon": Boolean(iconElement),
                },
                className
            )}
        >
            {iconElement}
            <span>{children}</span>
            {endElement}
        </Stack>
    )
}

export function ButtonBadge({ value }: { value: number }) {
    return <span className="btn-badge">{value}</span>
}
